export class WorkOrderCreate {
  constructor(
    public CategoryKey: number = 0,
    public Description: string = '',
    public Subcategory: string = '',
    public ProblemDescription: string = '',
    public Priority: string = '',
    public Safety: string = '',
    public TechSkillLevel: number,
    public TechSkill: string = '',
    public ProjectGUID: string = '',
    public TechVendor: string = '',
    public Result: string = '',
    public YonyxTranscript: string = '',
    public IsLowTemperaturePriority: boolean = false,
    public IsHighTemperaturePriority: boolean = false,
    public YonyxTranscriptId: string = null,
  ) { }
}
